<template>
<div class="chapter">
<div class="inner_page">
<p class="half"><a id="page_1"></a><span class="bold">BRITISH NAVAL TRAWLERS AND DRIFTERS</span></p>
<p class="title0"><span class="bold">IN TWO WORLD WARS</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Halftitle.vue?5f477fc2